<template>
    <div>

        <strong>Mon compte ameli</strong>
        <b-form-group class="pt-2">
            <b-form-checkbox
                v-model="ouvertureCompteAmeli"
                switch
                value="1"
                unchecked-value="0">
                Je souhaite obtenir mon code confidentiel pour créer mon <b-link href="https://assure.ameli.fr/PortailAS/appmanager/PortailAS/assure?_somtc=true" target="_blank">compte ameli</b-link> <b-icon v-b-modal.info-services-compte-ameli icon="info-circle" font-scale="1.5" @click.prevent></b-icon>
            </b-form-checkbox>
            <b-modal id="info-services-compte-ameli" hide-header centered :ok-only="true">
                Le compte ameli vous permet de suivre vos remboursements, d'effectuer votre commande de carte Vitale, de télécharger votre attestation de droits, d'accéder à la messagerie sécurisée, etc. ...
            </b-modal>
        </b-form-group>

        <div class="pt-3"><strong>Veuillez confirmer les mentions suivantes*</strong></div>
        <b-form-group class="pt-2">
            <b-form-checkbox
                v-model="acceptationReglesUtilisation"
                switch
                value="1"
                unchecked-value="0">
                Je certifie l'exactitude des informations saisie et accepte les règles d'utilisation sans réserve
            </b-form-checkbox>
        </b-form-group>

        <b-form-group class="pt-2">
            <b-form-checkbox
                v-model="adhesionAssuranceMaladieRegimeGeneral"
                switch
                value="1"
                unchecked-value="0">
                Je reconnais avoir pris connaissance des conditions générales d'inscription au service ci-dessus, et faire le choix de l'Assurance-Maladie du Régime Général de la Sécurité Sociale pour la prise en charge de mes frais de santé si je suis pensionné(e) de retraite de plusieurs régimes de protection sociale (droit d'option)
            </b-form-checkbox>
        </b-form-group>

        <div class="pt-4">
            <b-img :src="'data:image/jpeg;base64,' + captcha" rounded></b-img>
            <b-button variant="outline-secondary" @click="getCaptcha(true)" class="ml-2">
                <b-icon icon="arrow-clockwise" font-scale="1.5"></b-icon>
            </b-button>

            <b-form-group class="pt-3">
                <label for="input-captcha">
                    <strong>Veuillez saisir en chiffres la série ci-dessus</strong> <b-icon id="info-captcha" icon="info-circle" font-scale="1.5"></b-icon>
                    <b-tooltip target="info-captcha" triggers="hover">
                        Pourquoi celà ? Tout simplement pour vérifier que vous n'êtes pas un robot <b-icon icon="emoji-smile"></b-icon> Veuillez traduire un à un, chaque "mot" de cette série par sa valeur numérique correspondante
                    </b-tooltip>
                </label>
                <b-form-input
                id="input-captcha"
                placeholder="Exemple : 7809"
                v-model="captchaResponse"
                :state="captchaResponseState"
                @blur="controlCaptcha()"
                trim
                ></b-form-input>

                <b-form-invalid-feedback :state="captchaResponseState">
                    Le code saisi ne correspond pas
                </b-form-invalid-feedback>
            </b-form-group>
        </div>

        <BackNext
            :buttons="buttons"/>
  </div>
</template>

<script>
import BackNext from '@/components/BackNext'

export default {
  name: 'Validation',
  components: {
    BackNext
  },
  computed: {
        ouvertureCompteAmeli: {
            get() {
                return this.$store.ouvertureCompteAmeli
            },
            set(val) {
                this.$store.ouvertureCompteAmeli = val
            }
        },
        acceptationReglesUtilisation: {
            get() {
                return this.$store.acceptationReglesUtilisation
            },
            set(val) {
                this.$store.acceptationReglesUtilisation = val
            }
        },
        adhesionAssuranceMaladieRegimeGeneral: {
            get() {
                return this.$store.adhesionAssuranceMaladieRegimeGeneral
            },
            set(val) {
                this.$store.adhesionAssuranceMaladieRegimeGeneral = val
            }
        },
        captcha: {
            get() {
                return this.$store.captcha
            },
            set(val) {
                this.$store.captcha = val
            }
        },
        captchaResponse: {
            get() {
                return this.$store.captchaResponse
            },
            set(val) {
                this.$store.captchaResponse = val
            }
        },
        captchaResponseState: {
            get() {
                return this.$store.captchaResponseState
            },
            set(val) {
                this.$store.captchaResponseState = val
            }
        },

        checkAll: function() {
            return (this.acceptationReglesUtilisation == 1 &&
                    this.adhesionAssuranceMaladieRegimeGeneral == 1 &&
                    this.captchaResponseState) ? true : false;
        },

        buttons: function() {
            return {
                routes: {
                    back: 'PiecesAJoindre',
                    next: 'Enregistrement'
                },
                labels: {
                    next: 'Terminer'
                },
                next: this.$actions.getStepChecked('accueil') && this.$actions.getStepChecked('identite') && this.$actions.getStepChecked('coordonnees') && this.$actions.getStepChecked('regulariteDeSejour') && this.$actions.getStepChecked('piecesAJoindre') && this.$actions.getStepChecked('validation')
            }
        }

  },
  mounted() {

    // Renvoi vers l'URL du site
    if (this.$store.endOfInscription || !this.$actions.getStepChecked('accueil') || !this.$actions.getStepChecked('identite') || !this.$actions.getStepChecked('coordonnees') || !this.$actions.getStepChecked('regulariteDeSejour') || !this.$actions.getStepChecked('piecesAJoindre')) {
        window.location = this.$config.SITE
    }

    // Envoi un évenement onSetStepper pour mettre a jour l'étape
    this.$emit('onSetStepper', 'validation');

    // Initialise un nouveau captcha lors du tout premier chargement du composant
    if (this.captcha == null) {
        this.getCaptcha(true);
    }
  },
  methods: {
    // Génère un nouveau captcha
    getCaptcha(resetValue) {
        // Si resetValue est envoyé, alors on remet a null les variables de value et de state de l'input
        if (resetValue) {
            this.captchaResponse = this.captchaResponseState = null
        }
        this.$axios
            .get(this.$config.API + '/get-captcha', {
                headers: {
                    'Authorization': this.$store.token
                }
            })
            .then(response => {
                this.captcha = response.data.captcha
                this.$store.token = response.data.token
            });
    },

    // Controle la validité du code saisie
    controlCaptcha() {
        let regExp = /^[0-9]{4}$/g;
        if (this.captchaResponse && this.captchaResponse.match(regExp)) {

            // Force sans attendre le status a null pour désactiver immédiatement le bouton
            this.captchaResponseState = null;

            this.$axios
                .get(this.$config.API + '/control-captcha/' + this.captchaResponse, {
                    headers: {
                        'Authorization': this.$store.token
                    }
                })
                .then(response => {
                    // Met a jour le state selon le resultat obtenu
                    this.captchaResponseState = response.data.resultat
                    // Le code captcha était faux ? Alors on regénère un nouveau captcha
                    if (!this.captchaResponseState) {
                        this.getCaptcha(false)
                    }
                });
        } else {
            this.captchaResponseState = false
        }
    }

  },
  watch: {
    checkAll: function(val) {
        this.$actions.setStepChecked('validation', val);
    }
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Validation.vue